import { Box } from '@mui/material';
import { GoodsItemRoute, GoodsRoute } from '../../routes/allRoutes';
import { ServiceItemView } from '../serviceItemView/serviceItemView';
import { BreadcrumbsBar } from '../breadcrumbs/breadcrumbsBar';
import { appStyleMode } from '../../helpers/clientConfigs';
import { AppStyle } from '../../helpers/appStyle';
import { useServiceItem } from '../../hooks/useServiceItem';

export function GoodsItem() {
  const service = useServiceItem('goods');

  return (
    <Box sx={{ mt: appStyleMode === AppStyle.Mobile ? '0px' : '10px' }}>
      <BreadcrumbsBar
        paths={[
          { path: GoodsRoute, isLink: true },
          { path: GoodsItemRoute, title: service?.name },
        ]}
      />
      <ServiceItemView service={service} actionType="addToCart" />
    </Box>
  );
}
